import { Button } from "@component/button";

interface EmailVariable {
    variable: string;
    description: string;
}

interface EmailVariablesPanelProps {
    onClose: () => void;
    onInsertVariable: (variable: string) => void;
    isEditMode: boolean;
}

const emailVariables: EmailVariable[] = [
    {
        variable: "{{ firstNameCandidate }}",
        description: "The candidate's first name",
    },
    {
        variable: "{{ fullNameCandidate }}",
        description: "The candidate's full name (first + last)",
    },
    {
        variable: "{{ jobTitle }}",
        description: "The position title the candidate applied for",
    },
    {
        variable: "{{ companyName }}",
        description: "Your company's name",
    },
    {
        variable: "{{ hrName }}",
        description: "Your full name (first + last)",
    },
    {
        variable: "{{ assessmentLink }}",
        description: "The link to the candidate's screening",
    },
    {
        variable: "{{ assessmentExpiryDate }}",
        description: "The date the screening invitation expires",
    },
];

export default function EmailVariablesPanel({
    onClose,
    onInsertVariable,
    isEditMode,
}: EmailVariablesPanelProps) {
    return (
        <div
            className="w-full bg-gray-50 flex flex-col overflow-hidden"
            style={{ height: "100%", maxHeight: "100%", minWidth: "280px" }}
        >
            <div className="p-6 pb-0 flex-shrink-0" style={{ paddingBottom: "16px" }}>
                <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-900">Variables</h3>
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={onClose}
                        className="p-1 h-auto text-gray-500 hover:text-gray-700"
                    >
                        <span className="text-xl leading-none">×</span>
                    </Button>
                </div>

                <p className="text-sm text-gray-600">
                    Use variables to personalize your email subject and content.
                </p>
            </div>

            <div
                className="flex-1 overflow-y-auto px-4 pb-6"
                style={{ maxHeight: "calc(100% - 120px)" }}
            >
                <div
                    className="space-y-2 lg:space-y-3"
                    style={{ paddingTop: "16px", paddingBottom: "16px" }}
                >
                    {emailVariables.map((item, index) => (
                        <div
                            key={index}
                            className={`p-3 bg-card border border-border rounded-md transition-colors ${isEditMode
                                ? "cursor-pointer hover:bg-accent hover:border-accent-foreground/20"
                                : "cursor-default"
                                }`}
                            onClick={() => isEditMode && onInsertVariable(item.variable)}
                        >
                            <div className="font-mono text-xs lg:text-sm text-gray-800 mb-1 break-all">
                                {item.variable}
                            </div>
                            <div className="text-xs text-gray-600 leading-tight">
                                {item.description}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
